// extracted by mini-css-extract-plugin
export default {"menuBlock":"fF-z","title":"gF-z","nav":"hF-z","flexCell":"iF-z","facetLink":"jF-z"};